var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSharedocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.51 20.9998H4C2.9 20.9998 2 20.0998 2 18.9998V7.2998C2 6.7498 2.45 6.2998 3 6.2998C3.55 6.2998 4 6.7498 4 7.2998V18.9998H18.51C19.06 18.9998 19.51 19.4498 19.51 19.9998C19.51 20.5498 19.06 20.9998 18.51 20.9998Z",
    fill: "#161A49"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.67003 17.15C6.58003 17.15 6.48003 17.14 6.38003 17.11C5.85003 16.95 5.55003 16.4 5.71003 15.87C6.31003 13.87 7.36003 11.34 10.27 9.46003C11.67 8.56003 13.16 8.17003 13.22 8.16003C13.89 7.99003 14.4 7.93003 15.09 7.88003C16.01 7.81003 16.99 7.82003 18.64 7.85003C19.19 7.85003 20 7.86003 20.99 7.86003C21.54 7.86003 21.99 8.30003 21.99 8.85003C21.99 9.40003 21.55 9.85003 21 9.86003C19.99 9.86003 19.17 9.86003 18.61 9.85003C16.87 9.82003 16.03 9.82003 15.24 9.88003C14.65 9.92003 14.25 9.97003 13.71 10.11C13.7 10.11 12.46 10.44 11.35 11.15C9.01003 12.66 8.16003 14.68 7.63003 16.45C7.50003 16.88 7.10003 17.16 6.67003 17.16V17.15Z",
    fill: "#4FB74A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.64 14.6796C16.4 14.6796 16.16 14.5996 15.97 14.4196C15.56 14.0496 15.53 13.4196 15.9 13.0096L19.63 8.86965L15.63 4.68965C15.25 4.28965 15.26 3.65965 15.66 3.27965C16.06 2.89965 16.69 2.90965 17.07 3.30965L21.55 7.98965C22 8.44965 22.01 9.19965 21.58 9.68965L17.38 14.3496C17.18 14.5696 16.91 14.6796 16.64 14.6796Z",
    fill: "#4FB74A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharedocument);
export default __webpack_public_path__ + "static/media/sharedocument.e5ca9eb77058abdb85748649e2ce671e.svg";
export { ForwardRef as ReactComponent };